import { RootState } from '../Common/store/rootReducer';
import { createSelector } from 'reselect';
import { activeCTSlugSelector } from '../List/listSelectors';
import { defaultInitialState } from './filterReducer';

export const filterStateSelector = (state: RootState) => state.filters;

export const activeFilterStateSelector = createSelector(
    activeCTSlugSelector,
    filterStateSelector,
    (activeCTSlug, filters) => {
        if (filters[activeCTSlug] === undefined) {
            return defaultInitialState.startsWith;
        }
        return filters[activeCTSlug];
    },
);

export const startsWithSelector = createSelector(
    activeCTSlugSelector,
    filterStateSelector,
    (activeCTSlug, filters) => {
        if (filters[activeCTSlug] === undefined) {
            return defaultInitialState.startsWith;
        }
        return filters[activeCTSlug].startsWith;
    },
);

export const searchTermSelector = createSelector(
    activeCTSlugSelector,
    filterStateSelector,
    (activeCTSlug, filters) => {
        if (filters[activeCTSlug] === undefined) {
            return defaultInitialState.searchTerm;
        }
        return filters[activeCTSlug].searchTerm;
    },
);

export const activePageIndexSelector = createSelector(
    activeCTSlugSelector,
    filterStateSelector,
    (activeCTSlug, filters) => {
        if (filters[activeCTSlug] === undefined) {
            return defaultInitialState.activePageIndex;
        }
        return filters[activeCTSlug].activePageIndex;
    },
);

export const dynamicFiltersSelector = createSelector(
    activeCTSlugSelector,
    filterStateSelector,
    (activeCTSlug, filters) => {
        if (filters[activeCTSlug] === undefined) {
            return defaultInitialState.dynamicFilters;
        }
        return filters[activeCTSlug].dynamicFilters;
    },
);

export const areFiltersAppliedSelector = createSelector(
    activeCTSlugSelector,
    filterStateSelector,
    (activeCTSlug, filters) => {
        if (!filters[activeCTSlug]) {
            return false;
        }

        const { searchTerm, startsWith, dynamicFilters } = filters[
            activeCTSlug
        ];

        return (
            searchTerm !== '' ||
            startsWith !== '' ||
            JSON.stringify(dynamicFilters) !== '{}'
        );
    },
);
